module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "chapter4b"
  }, [_c('strong', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent4"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454919667_epub_c01_r1"
    }
  }, [_vm._v("  1    “You Are a Complete Disappointment”")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent4"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454919667_epub_c02_r1"
    }
  }, [_vm._v("  2    Of Atomic FireBalls"), _c('sup', [_vm._v("®")]), _vm._v(" and Talking Cows")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent4"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454919667_epub_c03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  3    The Great Meatball Pizza Incident")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent4"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454919667_epub_c04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  4    Welcome to the Summer of Suck")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent4"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454919667_epub_c05_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  5    How to Win Friends and Influence Idiots")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent4"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454919667_epub_c06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  6    “You Built a Computer When You Were Eight, and Then… Nothing!!”")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent4"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454919667_epub_c07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  7    Papa Joe")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent4"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454919667_epub_c08_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  8    Requiem")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent4"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454919667_epub_c09_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  9    Punching Back")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent4"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454919667_epub_c10_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10    (Talkin’ ’Bout) My GGGGeneration")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent4"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454919667_epub_c11_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11    Brothers and Sisters")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent4"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454919667_epub_c12_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12    Mom")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent4"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454919667_epub_c13_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13    From Mauler to Mahler")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent4"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454919667_epub_c14_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14    I Am Just a Jeepster for Your Love")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent4"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454919667_epub_c15_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15    Freedom")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent4a"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454919667_epub_ack_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent4b"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454919667_epub_ata_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("About the Author")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32c01e00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454919667_epub_toc_r1.vue
// module id = 78
// module chunks = 0